// npm
import React from "react";
import { connect } from "react-redux";
import { check } from "@xams-utils/check-types";

// material-ui
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import LinearProgress from "@material-ui/core/LinearProgress";
import withStyles from "@material-ui/core/styles/withStyles";

// redux (selectors)
import { getExamData } from "redux/reducers/selectors";
import {
    getFormRunGuid,
    getAwaitingExtension,
    getContentData,
} from "redux/reducers/exam/selectors";
import { getQuestionDataById } from "redux/reducers/exam/content/questions/selectors";
import {
    getCurrentQuestionId,
    getQuestionsData,
} from "redux/reducers/exam/content/selectors";
import { getNumber } from "redux/reducers/exam/content/questions/question/selectors";
import { getTimeData } from "redux/reducers/exam/selectors";
import { getExamElapsedTime } from "redux/reducers/exam/time/selectors";

import { dashApi } from "libs/api/interface/api-dash";
import { hasExtended, secondsToMinutes } from "./extendable-popup-helper";
import { assessmentApi } from "libs/api/interface/api-assessment";
import { getTimeStamp } from "utils/time-stamp";

const EXTEND_STATES = {
    CONFIRMATION: 0,
    REQUEST: 1,
    WAITING: 2,
    RECEIVED: 3,
    FINISHING: 4,
};

class ExtendablePopup extends React.Component {
    constructor(props) {
        super(props);

        this.startHub = this.startHub.bind(this);
        this.closeHub = this.closeHub.bind(this);
        this.getTitle = this.getTitle.bind(this);
        this.getMessage = this.getMessage.bind(this);
        this.getButtons = this.getButtons.bind(this);

        this.handleDummyTimer = this.handleDummyTimer.bind(this);

        this.hubConnection = null;
        this.examName = "Paper";
        // this.dummyExpand = 1 * 60;

        this.state = { extendable: null, connected: false, status: null };
    }

    componentDidUpdate(prevProps) {
        const { show: prevShow } = prevProps;
        const { show, awaitingExtension } = this.props;

        if (!prevShow && show) {
            if (awaitingExtension) {
                this.setState({ status: EXTEND_STATES.WAITING });
                this.startHub();
            } else {
                const { formRunGuid, elapsedTime, page } = this.props;
                this.setState({ status: EXTEND_STATES.CONFIRMATION });
                const payload = {
                    formRunGuid,
                    timeRemaining: 1,
                    elapsedTime,
                    page,
                    ClientTime: getTimeStamp(),
                };

                assessmentApi.saveExamTime(payload);
            }
        } else if (prevShow && !show) {
            this.closeHub();
        }
    }

    startHub() {
        const { subscribe } = dashApi;
        const { formRunGuid } = this.props;

        console.log("Starting HUB", formRunGuid);

        this.hubConnection = subscribe({ formRunGuid });

        this.setState({ connected: true });

        this.hubConnection.on("dashevent", (msg) => {
            if (check.nonEmptyString(msg)) {
                console.log("Received hub event: " + msg);

                const data = JSON.parse(msg);

                if (check.nonEmptyObject(data)) {
                    const { extendable } = data;
                    this.setState({
                        extendable: check.number(extendable) ? extendable : 0,
                        status: EXTEND_STATES.RECEIVED,
                    });
                }
            }
        });
        if (this.dummyExpand) {
            this.dummyTimer = setTimeout(this.handleDummyTimer, 5 * 1000);
        }
    }

    closeHub() {
        if (this.hubConnection != null) {
            console.log("Stopping signalR..");
            this.hubConnection.stop();
        }
    }

    componentWillUnmount() {
        this.closeHub();
        clearTimeout(this.dummyTimer);
    }

    handleDummyTimer() {
        const extendable = this.dummyExpand;

        this.setState({
            extendable: check.number(extendable) ? extendable : 0,
            status: EXTEND_STATES.RECEIVED,
        });
    }

    handleClose() {
        const { onFinish, setTimeRemaining } = this.props;
        // const { extendable } = this.state;
        const extendable = 0;

        this.closeHub();

        if (check.number(extendable)) {
            console.log("handleClose", extendable);
            setTimeRemaining(extendable * 1000);
        }

        onFinish(check.number(extendable) ? extendable : 0);
    }

    getTitle = () => {
        const { status, extendable } = this.state;
        if (status === EXTEND_STATES.CONFIRMATION) {
            return `Extend ${this.examName}`;
        } else if (status === EXTEND_STATES.REQUEST) {
            return `Requesting Extension`;
        } else if (status === EXTEND_STATES.WAITING) {
            return "Waiting For Response";
        } else if (
            status === EXTEND_STATES.RECEIVED ||
            status === EXTEND_STATES.FINISHING
        ) {
            return hasExtended(extendable)
                ? `${this.examName} Extended`
                : `${this.examName} Not Extended`;
        }
        return "";
    };

    getMessage() {
        const { status, extendable } = this.state;
        if (status === EXTEND_STATES.CONFIRMATION) {
            return `Do you want to request that this ${this.examName.toLowerCase()} is extended?`;
        } else if (status === EXTEND_STATES.REQUEST) {
            return `Requesting extension of ${this.examName.toLowerCase()} from invigilator`;
        } else if (status === EXTEND_STATES.WAITING) {
            return `Waiting for invigilator to acknowledge request for ${this.examName.toLowerCase()} extension`;
        } else if (status === EXTEND_STATES.RECEIVED) {
            return hasExtended(extendable)
                ? `Invigilator has agreed to extend this ${this.examName.toLowerCase()} by ${secondsToMinutes(
                      extendable
                  )}`
                : `Invigilator has not agreed to extend this ${this.examName.toLowerCase()}. Your ${this.examName.toLowerCase()} will finish now`;
        } else if (status === EXTEND_STATES.FINISHING) {
            return hasExtended(extendable)
                ? `Extending ${this.examName.toLowerCase()}`
                : `Finishing ${this.examName.toLowerCase()}`;
        }

        return "";
    }

    getProgress() {
        const { status } = this.state;
        const { classes } = this.props;

        if (
            status === EXTEND_STATES.REQUEST ||
            status === EXTEND_STATES.WAITING ||
            status === EXTEND_STATES.FINISHING
        ) {
            return (
                <div className={classes.progress}>
                    <LinearProgress />
                </div>
            );
        }
    }

    getButtons() {
        const { status, extendable } = this.state;
        const buttonProps = { variant: "contained", color: "primary" };
        if (status === EXTEND_STATES.CONFIRMATION) {
            return (
                <DialogActions>
                    <Button
                        onClick={() => this.handleButton(false)}
                        {...buttonProps}
                    >
                        No
                    </Button>
                    <Button
                        onClick={() => this.handleButton(true)}
                        {...buttonProps}
                    >
                        Yes
                    </Button>
                </DialogActions>
            );
        } else if (
            status === EXTEND_STATES.REQUEST ||
            status === EXTEND_STATES.WAITING
        ) {
            return (
                <DialogActions>
                    <Button
                        onClick={() => this.handleButton(false)}
                        {...buttonProps}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            );
        } else if (status === EXTEND_STATES.RECEIVED) {
            const label = hasExtended(extendable)
                ? `Continue ${this.examName}`
                : `Finish ${this.examName}`;
            return (
                <DialogActions>
                    <Button
                        onClick={() =>
                            this.handleButton(hasExtended(extendable))
                        }
                        {...buttonProps}
                    >
                        {label}
                    </Button>
                </DialogActions>
            );
        }
        return null;
    }

    handleButton(button) {
        const { status, extendable } = this.state;
        const { onFinish, orgID, formRunGuid } = this.props;

        if (!button) {
            onFinish(0);
        }

        if (status === EXTEND_STATES.CONFIRMATION) {
            if (button === true) {
                this.setState({ status: EXTEND_STATES.REQUEST });
                assessmentApi
                    .getExtendExamAlert({ orgID, formRunGuid })
                    .then(() => {
                        this.setState({ status: EXTEND_STATES.WAITING });
                        this.startHub();
                    });
            }
        } else if (status === EXTEND_STATES.RECEIVED) {
            this.setState({ status: EXTEND_STATES.FINISHING });
            onFinish(extendable);
        }
    }

    render() {
        const { show, classes } = this.props;

        return (
            <Dialog
                open={show}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                size="sm"
                fullWidth={true}
                disableBackdropClick={true}
                disableEscapeKeyDown={true}
            >
                <DialogTitle id="alert-dialog-title">
                    <div className={classes.title}>
                        <AccessTimeIcon fontSize="large" />
                        {this.getTitle()}
                    </div>
                </DialogTitle>
                <DialogContent style={{ minHeight: "180px" }}>
                    <DialogContentText id="alert-dialog-description">
                        {this.getMessage()}
                    </DialogContentText>
                    {this.getProgress()}
                </DialogContent>
                {this.getButtons()}
            </Dialog>
        );
    }
}

const styles = ({ spacing }) => ({
    title: {
        display: "flex",
        gap: `${spacing.unit * 2}px`,
        justifyContent: "flex-left",
        alignItems: "center",
    },
    progress: {
        paddingTop: spacing.unit * 3,
    },
});

ExtendablePopup = withStyles(styles)(ExtendablePopup);

const mapStoreToProps = (store) => {
    const examData = getExamData(store);
    const formRunGuid = getFormRunGuid(examData);
    const awaitingExtension = getAwaitingExtension(examData);
    const elapsedTime = getExamElapsedTime(getTimeData(examData));
    const contentData = getContentData(examData);
    const questionsData = getQuestionsData(contentData);

    const questionId = getCurrentQuestionId(contentData);
    const questionData = getQuestionDataById(questionsData)(questionId);
    const page = getNumber(questionData);

    return { formRunGuid, awaitingExtension, elapsedTime, page };
};

ExtendablePopup = connect(mapStoreToProps)(ExtendablePopup);

export { ExtendablePopup };
